import './EntityLabels.scss';

const AccountLabel = ({account, small = false}) => (
    <span className={`entity-label entity-label--account ${small ? 'entity-label--account--small' : ''}`}>
        <span className="entity-label__body">
            <span className="entity-label__name">{account.title}</span>
            {account.currencyCode && <span className="entity-label__meta">{account.currencyCode}</span>}
            {account.sourceName && <span className="entity-label__tag">{account.sourceName}</span>}
        </span>
    </span>
);

export default AccountLabel;